import React from 'react'
import { SelectComponent } from '../../shared/select/select.component'
import { CheckBoxComponent } from '../../shared/checkbox/checkbox.component'


export class PaymentsConds extends React.Component {
  constructor(props) {
    super(props)
  }

  changedPaymentType(name, val) {
    let res = 'cash'
    if(name == 'cash' && val) {
      res = 'cash'
    } else if(name == 'cash' && !val) {
      res = 'card'
    } else if(name == 'card' && val) {
      res = 'card'
    } else if(name == 'card' && !val) {
      res = 'cash'
    }

    this.props.onChange(res)
  }

  render() {
    if(this.props.settings.payment_system == 'turned_off' || this.props.settings.mobile_only_payment)
      return null
    const pt = this.props.paymentType
    return (
      <div>
        <div className="h4">
          Оплата
        </div>

        <div>
          <CheckBoxComponent
            title="Оплатить картой"
            value={pt == 'card'}
            onChange={(v)=> {this.changedPaymentType('card', v)}}
            cl="mr-10"
          />

          <CheckBoxComponent
            title="Наличными курьеру"
            value={pt == 'cash'}
            onChange={(v)=> {this.changedPaymentType('cash', v)}}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/payments_conds.component.jsx